import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Trash2, MailOpen, User, Phone, Calendar } from 'lucide-react';
import Swal from 'sweetalert2';
import './AdminInquiries.css';
const API_URL = 'https://api.sohanihandicrafts.com:5010';
const AdminInquiries = () => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchMessages = async () => {
        try {
            const res = await axios.get(`${API_URL}/api/contact/all`);
            setMessages(res.data);
        } catch (err) { console.error(err); }
        finally { setLoading(false); }
    };

    useEffect(() => { fetchMessages(); }, []);

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Delete this inquiry?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await axios.delete(`${API_URL}/api/contact/delete/${id}`);
                fetchMessages();
            }
        });
    };

    return (
        <div className="adm-msg-wrapper">
            <div className="adm-msg-header">
                <h1>Customer Inquiries</h1>
                <p>Manage messages received from the contact page</p>
            </div>

            <div className="adm-msg-card">
                <div className="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Customer</th>
                                <th>Contact Info</th>
                                <th>Message</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {messages.map((m) => (
                                <tr key={m._id}>
                                    <td>
                                        <div className="adm-msg-date">
                                            <Calendar size={14}/> {new Date(m.createdAt).toLocaleDateString()}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="adm-msg-user">
                                            <User size={16} /> <strong>{m.name}</strong>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="adm-msg-contact">
                                            <p><MailOpen size={14}/> {m.email}</p>
                                            <p><Phone size={14}/> {m.phone}</p>
                                        </div>
                                    </td>
                                    <td className="adm-msg-content-cell">
                                        <div className="adm-msg-text-bubble">{m.message}</div>
                                    </td>
                                    <td>
                                        <button className="del-btn" onClick={() => handleDelete(m._id)}>
                                            <Trash2 size={18}/>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {messages.length === 0 && !loading && <p className="no-data">No messages found.</p>}
                </div>
            </div>
        </div>
    );
};

export default AdminInquiries;